<!-- Button trigger modal
<button type="button" class="rts-btn btn-primary text-light mx-w-100" data-bs-toggle="modal"
  data-bs-target="#membershipModal">
  open modal
</button> -->

<!-- Modal -->
<div class="modal fade" id="membershipModal" tabindex="-1" aria-labelledby="membershipModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="membershipModalLabel">{{"MEMBERSHIP.APPLY_FOR_MEMBERSHIP"|translate}}🎉</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeMembershipModal()"></button>
      </div>
      <div class="modal-body">
        <p>{{"MEMBERSHIP.MESSAGE_FOR_APPLYING" | translate}}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="rts-btn btn-primary text-light" data-bs-dismiss="modal" (click)="closeMembershipModal()">
          {{"MEMBERSHIP.CLOSE" |translate}}</button>
        <button type="button" class="rts-btn btn-secondary text-light" data-bs-dismiss="modal" [routerLink]="'/profile/memberships'"
        (click)="closeMembershipModal()">
            {{"MEMBERSHIP.SUBSCRIBE" | translate}}
        </button>
      </div>
    </div>
  </div>
</div>